import { apiPostJson } from './apiClient'

type UserInfo = {
  username?: string | null
  full_name?: string | null
}

export const sendTelegramNotification = async (message: string, user?: UserInfo) => {
  try {
    void user
    await apiPostJson<any>('/api/telegram/send', {
      text: message,
      parse_mode: 'HTML',
    })
  } catch (error) {
    console.error('Error sending Telegram notification:', error)
  }
};
